/**
 * 2019-04-13
 * handan
 * 处理用户头像等信息
 */

import { myjsonp } from "../utils/http/http";

const getUserInfo = async()=>{
	try {
		let res = await myjsonp("/getUserInfo");
		if(res.status==="1"){
			let usephoto = res.userInfo.picUrl ? "//pic1.58cdn.com.cn" + res.userInfo.picUrl : "//img.58cdn.com.cn/job/pc/qy/hx/defaultphoto.png";
			let userealname = res.userInfo.userName ? res.userInfo.userName : (res.userInfo.nickName ? res.userInfo.nickName : "未知昵称");
			return Promise.resolve({userealname,usephoto});
		}else{
			return Promise.reject(res.message);
		}
	} catch (error) {
		return Promise.reject(error);
	}
	
}


export default getUserInfo
